import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './AppShutdown.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    'get /app-status/shutdown': 200,
  })
}

export const getAppStatusShutdown = () => {}

export const getFeatureMaintenanceStatus = () =>
  client({
    url: '/feature-status?platform=web',
    method: 'get',
  })
